import React, { useState, useRef, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';

const UserMenu: React.FC = () => {
  const { user, logout, isAuthenticated } = useAuth();
  const [open, setOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  if (!isAuthenticated || !user) return null;

  const initials = user.name && user.name.trim()
    ? user.name.trim().split(' ').filter(n => n.length > 0).map(n => n[0]).join('').toUpperCase().slice(0, 2)
    : user.email?.[0]?.toUpperCase() ?? '?';

  return (
    <div ref={menuRef} style={{ position: 'fixed', top: '12px', right: '24px', zIndex: 99999 }}>

      {/* Botón flotante */}
      <button
        onClick={() => setOpen(!open)}
        style={{
          width: '48px', height: '48px', borderRadius: '50%',
          border: '2px solid #fff', cursor: 'pointer',
          overflow: 'hidden', padding: 0,
          boxShadow: '0 4px 16px rgba(0,0,0,0.25)',
          transition: 'transform 0.2s, box-shadow 0.2s',
          background: '#2563eb',
        }}
        onMouseEnter={e => { e.currentTarget.style.transform = 'scale(1.08)'; e.currentTarget.style.boxShadow = '0 6px 20px rgba(0,0,0,0.35)'; }}
        onMouseLeave={e => { e.currentTarget.style.transform = 'scale(1)'; e.currentTarget.style.boxShadow = '0 4px 16px rgba(0,0,0,0.25)'; }}
      >
        {user.avatar ? (
          <img src={user.avatar} alt={user.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
        ) : (
          <span style={{ color: 'white', fontSize: '1rem', fontWeight: 700 }}>{initials}</span>
        )}
      </button>

      {/* Menú desplegable — cae hacia abajo */}
      {open && (
        <div style={{
          position: 'absolute', top: '60px', right: 0,
          background: '#fff', borderRadius: '16px',
          boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
          border: '1px solid #e2e8f0',
          width: '260px', overflow: 'hidden',
          animation: 'fadeInDown 0.2s ease',
        }}>

          {/* Header con foto y datos */}
          <div style={{
            padding: '1.25rem 1rem', background: '#f8fafc',
            borderBottom: '1px solid #e2e8f0',
            display: 'flex', alignItems: 'center', gap: '12px',
          }}>
            <div style={{
              width: '46px', height: '46px', borderRadius: '50%',
              overflow: 'hidden', flexShrink: 0,
              background: '#2563eb', display: 'flex',
              alignItems: 'center', justifyContent: 'center',
              border: '2px solid #e2e8f0',
            }}>
              {user.avatar ? (
                <img src={user.avatar} alt={user.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              ) : (
                <span style={{ color: 'white', fontSize: '1.1rem', fontWeight: 700 }}>{initials}</span>
              )}
            </div>
            <div style={{ minWidth: 0 }}>
              <p style={{ margin: 0, fontWeight: 700, fontSize: '0.9rem', color: '#0f172a', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {user.name || 'Usuario'}
              </p>
              <p style={{ margin: 0, fontSize: '0.78rem', color: '#64748b', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {user.email}
              </p>
            </div>
          </div>

          {/* Opciones */}
          <div style={{ padding: '0.5rem' }}>
            <button
              onClick={() => {
                setOpen(false);
                const modalElement = document.getElementById('loginModal');
                if (modalElement) {
                  const modal = new (window as any).bootstrap.Modal(modalElement);
                  modal.show();
                }
              }}
              style={{
                width: '100%', padding: '0.65rem 0.85rem',
                background: 'transparent', border: 'none',
                borderRadius: '8px', cursor: 'pointer',
                display: 'flex', alignItems: 'center', gap: '10px',
                fontSize: '0.88rem', color: '#374151', fontWeight: 500,
                transition: 'background 0.15s',
                textAlign: 'left',
              }}
              onMouseEnter={e => e.currentTarget.style.background = '#f1f5f9'}
              onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
            >
              <i className="fas fa-exchange-alt" style={{ color: '#6b7280', width: '16px' }} />
              Cambiar cuenta
            </button>

            <button
              onClick={() => {
                logout();
                setOpen(false);
              }}
              style={{
                width: '100%', padding: '0.65rem 0.85rem',
                background: 'transparent', border: 'none',
                borderRadius: '8px', cursor: 'pointer',
                display: 'flex', alignItems: 'center', gap: '10px',
                fontSize: '0.88rem', color: '#ef4444', fontWeight: 500,
                transition: 'background 0.15s',
                textAlign: 'left',
              }}
              onMouseEnter={e => e.currentTarget.style.background = '#fef2f2'}
              onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
            >
              <i className="fas fa-sign-out-alt" style={{ color: '#ef4444', width: '16px' }} />
              Cerrar sesión
            </button>
          </div>
        </div>
      )}

      <style>{`
        @keyframes fadeInDown {
          from { opacity: 0; transform: translateY(-8px); }
          to   { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
};

export default UserMenu;